import { Box } from '@eatclubapp/ec-component-library';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import './ToggleGroupStyles.css';

/**
 * TODO copied from component library due to bug with single select. move back asap
 */
export const ToggleGroup = ({
  className = '',
  style = {},
  items = [],
  label = '',
  value = [],
  onSelect = () => {},
  singleChoice = true, // TODO change to multiselect
  disabled = false,
  error = null,
  showCheckmark = false,
}) => {
  const itemRefs = [];
  const setRef = (ref) => {
    itemRefs.push(ref);
  };

  const [hover, setHover] = useState(null);

  /**
   * Update the value array to add or remove the clicked item
   * @param clickedItem
   */
  const toggleItem = (clickedItem, e) => {
    if (disabled) {
      return;
    }

    // Don't use lists if only one is allowed
    if (singleChoice) {
      onSelect(clickedItem, e);
      return;
    }

    // TODO max selections for > 1

    if (!value.includes(clickedItem)) {
      onSelect([...value, clickedItem]);
    } else {
      onSelect(value.filter((itemValue) => itemValue !== clickedItem));
    }
  };

  const handleKeyPress = (event) => {
    items.forEach((item, index) => {
      const itemRef = itemRefs[index];

      // Return early if this is not the active element
      if (document.activeElement !== itemRef) {
        return;
      }

      // Blur on escape
      if (event.key === 'Escape') {
        document.activeElement.blur();
      }

      // If press enter, select the hovered item
      if (event.key === 'Enter') {
        toggleItem(item.value);
      }
    });
  };

  // Add keyboard event listener to input
  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  });

  const styles = {
    container: {
      ...style,
      ...style?.container,
    },
    label: {
      marginBottom: '10px',
      ...style?.label,
    },
    groupContainer: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      gap: '10px',
      transitionDuration: '0.05s',
      // flexGrow: 1,
      width: '100%',
      ...style?.groupContainer,
    },
    groupOptionContainer: {
      display: 'flex',
      width: '170px',
      ...style?.groupOptionContainer,
    },
    option: {
      display: 'inline-flex',
      boxSizing: 'border-box',
      alignItems: 'center',
      textDecoration: 'none',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      backgroundColor: '#ffffff',
      border: '1px solid #313131',
      borderRadius: '100px',
      color: '#313131',
      padding: '10px 20px',
      fontSize: '16px',
      cursor: 'pointer',
      userSelect: 'none',
      position: 'relative',
      gap: '12px',
      flexGrow: 0,
      ...style?.option,
    },
    selectedOption: {
      border: '1px solid #28524B',
      ...style?.selectedOption,
    },
    hoveredOption: {
      ...style?.hoveredOption,
    },
    disabledOption: {
      backgroundColor: '#F0F0F0',
      color: '#6E6E6D',
      border: '1px solid #F0F0F0',
      cursor: 'default',
      ...style?.disabledOption,
    },
    selectedAndDisabledOption: {
      // Since it can be both
      // color: "#FFFFFF",
      backgroundColor: '#F0F0F0',
      border: '1px solid #28524B',
      cursor: 'default',
      ...style?.selectedAndDisabledOption,
    },
    optionLabel: {
      ...style?.optionLabel,
    },
    error: {
      fontSize: '12px',
      color: '#E7554B',
      ...style?.error,
    },
    iconContainer: {
      display: 'flex',
      ...style?.iconContainer,
    },
    iconContainerSelected: {
      ...style?.iconContainerSelected,
    },
    checkmark: {
      ...style?.checkmark,
    },
  };

  return (
    <Box className={`toggle-group-container ${className}`} style={styles.container}>
      {label && <Box style={styles.label}>{label}</Box>}
      <Box className='toggle-group' style={styles.groupContainer}>
        {items.map((item) => {
          const isSelected = value === item.value || (!singleChoice && value?.includes(item.value));

          return (
            <Box
              key={item.value}
              ref={setRef}
              style={styles.groupOptionContainer}
              tabIndex={disabled ? -1 : 0}
            >
              <Box
                className={`toggle-group-option ${isSelected && 'toggle-group-option-selected'}
              ${disabled && 'toggle-group-option-disabled'}`}
                onMouseEnter={() => setHover(item?.value)}
                onMouseLeave={() => setHover(null)}
                style={{
                  ...styles.option,
                  ...(isSelected && styles.selectedOption),
                  ...(hover !== null && hover === item?.value && styles?.hoveredOption),
                  ...(disabled && styles.disabledOption),
                }}
                onClick={(e) => toggleItem(item.value, e)}
              >
                {showCheckmark && (
                  <Box
                    style={{
                      ...styles.iconContainer,
                      ...(isSelected && styles.iconContainerSelected),
                    }}
                  />
                )}

                <Box style={{ ...styles.optionLabel }}>{item.label}</Box>
              </Box>
            </Box>
          );
        })}
      </Box>
      {error && <Box style={styles.error}>{error}</Box>}
    </Box>
  );
};

ToggleGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  InputProps: PropTypes.shape({}),
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.shape({}),
        PropTypes.number,
      ]),
      label: PropTypes.string,
    }),
  ),
  singleChoice: PropTypes.bool, // Whether only one option can be selected
};
